import * as React from 'react';
const { useEffect } = React;
import { bindActionCreators } from 'redux';

import { withAutoUpdate, IBusinessState } from '../../../../../flux';
import { useAuthContext } from '../../../../auth/context';
import { tenantActionsPack } from '../../../actions';
import { tenantSelectorsPack } from '../../../selectors';
import XPayeeRequsites from './payee-requisites.view';


type PayeeRequsitesProps = {
	isFetching?: boolean;
	tenantID?: number;
	tenant?: Tenant;
	isSessionContextLoaded?: boolean;
	fetchSessionContext?: (ticketUID: string) => void;
	fetchTenantByID: (tenantID: number) => void;
	updateTenant: (tenant: Tenant) => void;
};

const PayeeRequsites: React.SFC<PayeeRequsitesProps> = (props) => {
	const {
		isFetching,
		tenantID,
		tenant,
		isSessionContextLoaded,
		fetchSessionContext,
		updateTenant,
		...rest
	} = props;
	const { ticketUID } = useAuthContext();

	useEffect(() => {
		!isSessionContextLoaded && fetchSessionContext(ticketUID);
	}, [ticketUID, isSessionContextLoaded]);

	return (
		<XPayeeRequsites
			{...rest}
			isFetching={isFetching}
			tenant={tenant}
			onUpdateTenant={updateTenant}
		/>
	);
}

const selectIsFetching = (state) => tenantSelectorsPack.selectAsyncSessionContext.selectIsFetching(state)
	|| tenantSelectorsPack.selectAsyncTenant.selectIsFetching(state);

function mapStateToProps(state): Partial<PayeeRequsitesProps> {
	return {
		isFetching: selectIsFetching(state),
		isSessionContextLoaded: tenantSelectorsPack.selectAsyncSessionContext.selectIsLoaded(state),
		tenantID: tenantSelectorsPack.selectTenantID(state),
		tenant: tenantSelectorsPack.selectAsyncTenant.selectItem(state),
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		fetchSessionContext: tenantActionsPack.actions.fetchSessionContext,
		fetchTenantByID: tenantActionsPack.actions.fetchTenantByID,
		updateTenant: tenantActionsPack.actions.updateTenant,
	}, dispatch);
}

export default withAutoUpdate<IBusinessState, PayeeRequsitesProps>(mapStateToProps, mapDispatchToProps)({
	tenantDidInvalidate: [
		tenantSelectorsPack.selectAsyncTenant.selectDidInvalidate,
		({ tenantID, fetchTenantByID }) => tenantID > 0 && fetchTenantByID(tenantID),
		{
			detectPropChange: ({ tenantID }) => tenantID, 
		}
	],
})(PayeeRequsites);
